export default "__VITE_ASSET__DA1cAvv___"